"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusLabel = exports.ResistType = exports.CommandShortcut = exports.FairyMagicRankMap = exports.FairyMagicType = exports.MagiSphereType = exports.God = exports.BuffLabel = exports.JobLabel = void 0;
exports.JobLabel = {
    adventure: '冒険者レベル',
    fighter: 'ファイター',
    grappler: 'グラップラー',
    battledancer: 'バトルダンサー',
    fencer: 'フェンサー',
    shooter: 'シューター',
    sorcerer: 'ソーサラー',
    conjurer: 'コンジャラー',
    priest: 'プリースト',
    fairytamer: 'フェアリーテイマー',
    magitech: 'マギテック',
    scout: 'スカウト',
    ranger: 'レンジャー',
    sage: 'セージ',
    enhancer: 'エンハンサー',
    bard: 'バード',
    rider: 'ライダー',
    alchemist: 'アルケミスト',
    druid: 'ドルイド',
    demonruler: 'デーモンルーラー',
    wizard: 'ウィザード',
    geomancer: 'ジオマンサー',
    warleader: 'ウォーリーダー',
    mystic: 'ミスティック',
    phigicalmaster: 'フィジカルマスター',
    grimoire: 'グリモワール',
    aristocracy: 'アリストクラシー',
    artisan: 'アーティザン',
};
exports.BuffLabel = {
    ALL: '行為修正',
    ACT: '行動修正',
    ACC: '命中修正',
    AVO: '回避修正',
    MAG_POWER: '魔力修正',
    MAG_CAST: '魔法行使修正',
    VIT_RESIST: '生命抵抗修正',
    MND_RESIST: '精神抵抗修正',
    PHG_DAMAGE: '物理D増加',
    MAG_DAMAGE: '魔法D増加',
    // PHG_CRITCAL : '物理C修正',
    // MAG_CRITCAL : '魔法C修正',
};
exports.God = {
    RIFOTH: 'ライフォス',
    TIDAN: 'ティダン',
    ASTERIA: 'アステリア',
    GRENDARL: 'グレンダール',
    GAMEL: 'ガメル',
    SEEN: 'シーン',
    AEVE: 'イーヴ',
    HAROULA: 'ハルーラ',
    DALION: 'ダリオン',
    MILLIZA: 'ミリッツァ',
    MEALS: 'ミィルズ',
    R_MATA: 'アールマータ',
    FLUSIL: 'フルシル',
    STRUTSFORD: 'ストラスフォード',
    SUDDOUL: 'サドゥール',
    KILLHERE: 'キルヒア',
    MILTAVAL: 'ミルタバル',
    PALO: 'パロ',
    ARDENI: 'アーデニ',
};
exports.MagiSphereType = {
    LARGE: '大',
    MEDIUM: '中',
    SMALL: '小',
};
exports.FairyMagicType = {
    BASIC: '基本',
    FIRE: '炎',
    WATER: '水・氷',
    WIND: '風',
    EARTH: '土',
    SHINE: '光',
    DARK: '闇',
    CHAOS: '特殊',
};
exports.FairyMagicRankMap = {
    1: { elem4: 1, elem3: 0, all: { elem: 0, chaos: 0 } },
    2: { elem4: 2, elem3: 0, all: { elem: 0, chaos: 0 } },
    3: { elem4: 3, elem3: 4, all: { elem: 2, chaos: 1 } },
    4: { elem4: 4, elem3: 5, all: { elem: 3, chaos: 1 } },
    5: { elem4: 5, elem3: 6, all: { elem: 4, chaos: 1 } },
    6: { elem4: 6, elem3: 8, all: { elem: 4, chaos: 2 } },
    7: { elem4: 7, elem3: 9, all: { elem: 5, chaos: 2 } },
    8: { elem4: 8, elem3: 10, all: { elem: 6, chaos: 2 } },
    9: { elem4: 9, elem3: 12, all: { elem: 6, chaos: 3 } },
    10: { elem4: 10, elem3: 13, all: { elem: 7, chaos: 3 } },
    11: { elem4: 11, elem3: 14, all: { elem: 8, chaos: 3 } },
    12: { elem4: 12, elem3: 15, all: { elem: 8, chaos: 4 } },
    13: { elem4: 13, elem3: 15, all: { elem: 9, chaos: 4 } },
    14: { elem4: 14, elem3: 15, all: { elem: 10, chaos: 4 } },
    15: { elem4: 15, elem3: 15, all: { elem: 10, chaos: 5 } },
};
exports.CommandShortcut = {
    DEFENCE: 'def',
    ATTACK: 'atk',
    ITEM: 'item',
    MAGIC: 'magic',
    DAMAGE: 'dmg',
    DAMAGE_HALF: 'dmghalf',
    DAMAGE_HALF_S: 'hk',
    HEAL: 'heal',
    PACKAGE: 'pkg',
    SKILL: 'skill',
    ENHANCE: 'enhance',
    SONG: 'song',
    RIDING: 'riding',
    ALCHEMY: 'alchemy',
    GEOMANCY: 'geomancy',
    COMMAND: 'command',
    INITIATIVE: 'initiative',
    MONSTER: 'monster'
};
exports.ResistType = {
    NO_RESIST: '必中',
    NO_EFFECT: '消滅',
    HALF: '半減',
    REDUCTION: '短縮',
};
exports.StatusLabel = {
    DEX: '器用度',
    AGI: '敏捷度',
    STR: '筋力',
    VIT: '生命力',
    INT: '知力',
    MND: '精神力',
};
//# sourceMappingURL=static.js.map